import { render, staticRenderFns } from "./PageScroller.vue?vue&type=template&id=3b691b06&scoped=true&"
import script from "./PageScroller.vue?vue&type=script&lang=js&"
export * from "./PageScroller.vue?vue&type=script&lang=js&"
import style0 from "./PageScroller.vue?vue&type=style&index=0&id=3b691b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b691b06",
  null
  
)

export default component.exports